import { defineModule } from '../../manifest.js';
/**
 * C-2, the split model. The reporting infrastructure — read models, aggregation,
 * export, scheduling and global search — is mandatory Platform Core and is
 * declared as a required capability. This add-on sells the builder and
 * cross-module analytics; it grants the capability, never the data.
 *
 * SOLD AS "INTELLIGENCE" FROM PHASE 1. The display name changed; the module
 * key did not, and will not — it appears in entitlement records, audit events,
 * usage meters and invoices, and a key that is reused is a key that makes two
 * different things look like one in a billing dispute. C-4 already says a
 * marketing rename is catalogue data rather than a migration; this is that.
 *
 * Intelligence covers BI, analytics, cross-module insight surfaces and
 * AI-assisted insight presentation through the existing Stage 7 AI Gateway. It
 * is NOT the AI & Automation SKU, which is a separate, later module: agents,
 * automation and workflow design are that module's, and nothing here merges
 * the two. Nor is it global Ask TESSMA AI, which is a shell feature every
 * tenant has and no entitlement grants.
 */
export const manifest = defineModule({
    moduleKey: 'reports-analytics',
    name: 'Intelligence',
    description: 'Business intelligence: report builder, custom dashboards, cross-module analytics, ' +
        'consolidated enterprise reporting and AI-assisted insight presentation.',
    kind: 'add_on',
    sellable: true,
    navigationModuleKey: 'reports',
    features: [
        { key: 'reports_analytics.report_builder', description: 'Build custom reports' },
        { key: 'reports_analytics.custom_dashboards', description: 'Dashboards across modules' },
        {
            key: 'reports_analytics.cross_module_analytics',
            description: 'Metrics joining entitled modules',
        },
        {
            key: 'reports_analytics.consolidated_reporting',
            description: 'Reporting across legal entities',
        },
    ],
    editions: [
        {
            code: 'ed_01',
            description: 'Builder and dashboards',
            features: ['reports_analytics.report_builder', 'reports_analytics.custom_dashboards'],
            limits: ['user'],
        },
        {
            code: 'ed_02',
            description: 'Adds cross-module and consolidated reporting',
            features: [
                'reports_analytics.report_builder',
                'reports_analytics.custom_dashboards',
                'reports_analytics.cross_module_analytics',
                'reports_analytics.consolidated_reporting',
            ],
            limits: ['user', 'active_user'],
        },
    ],
    limitTypes: ['user', 'active_user'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: ['tenancy', 'hierarchy', 'identity', 'authz', 'audit', 'reporting', 'search'],
    optionalModules: [],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map